import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './AlertModal.css';

/**
 * Componente de Modal de Alerta Temporal
 * Se muestra encima de otros modales y se cierra automáticamente
 * 
 * @param {boolean} show - Controla si el modal se muestra
 * @param {function} onHide - Función que se ejecuta al cerrar el modal
 * @param {string} message - Mensaje a mostrar
 * @param {string} type - Tipo de alerta: 'success' o 'error'
 * @param {number} autoCloseDelay - Tiempo en ms antes de cerrar automáticamente (default: 3000)
 */
const AlertModal = ({ 
    show, 
    onHide, 
    message, 
    type = 'success',
    autoCloseDelay = 3000 
}) => {
    useEffect(() => {
        if (show && autoCloseDelay > 0) {
            const timer = setTimeout(() => {
                onHide();
            }, autoCloseDelay);
            return () => clearTimeout(timer);
        }
    }, [show, autoCloseDelay, onHide]);

    return (
        <Modal 
            show={show} 
            onHide={onHide}
            centered
            backdrop={true}
            backdropClassName="alert-modal-backdrop"
            keyboard={false}
            className="alert-modal-temporary"
            style={{ zIndex: 10000 }}
        >
            <Modal.Body 
                className={`alert-modal-body ${type === 'error' ? 'alert-error' : 'alert-success'}`}
                style={{ 
                    padding: '2rem',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '16px'
                }}
            >
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                    {type === 'error' ? '❌' : '✅'}
                </div>
                <h5 style={{ 
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: 'white'
                }}>
                    {type === 'error' ? 'Error' : 'Éxito'}
                </h5>
                <p style={{ 
                    margin: 0,
                    fontSize: '1rem',
                    color: 'rgba(255, 255, 255, 0.95)'
                }}>
                    {message}
                </p>
            </Modal.Body>
        </Modal>
    );
};

export default AlertModal;
